@if (authUser()) {
  <a [routerLink]="`/${link().url}`"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    class="root-container">
    {{ link().name }}
  </a>
}
